module.exports = __webpack_public_path__ + "img/spieleruebersicht.aa1c6267.png";